export default __webpack_public_path__ + "static/brian-bitmoji-d8cc0cdce4c284d641b3e52758eb2f00.png";